import classnames from 'classnames'

/**
 * @description Base loader definition
 *      USAGE
 *          <Loader
 *              *** PROPS ***
 *          />
 *
 *      PROPS - all props are optional
 *          height    - height of loader
 *          width     - width of loader
 *          className - additional CSS classes
 *
 */

interface LoaderProps {
    height?: number | string
    width?: number | string
    className?: string
}

/**
 * Render image loading
 *
 * @param {LoaderProps} props
 * @return {JSX.Element}
 */
const Loader = (props: LoaderProps) => {
    const {
        height,
        width,
        className,
    } = props

    const classes = className || ''

    return (
        <div className={classnames({
            'loader-container': true,
            [classes]: !!classes,
        })}
        >
            <img
                src="/images/loader.svg"
                height={height ?? undefined}
                width={width ?? undefined}
                alt="Loading..."
            />
        </div>
    )
}

export default Loader
